import React from "react";

export default class CommonUtils  {

    compareDate = (date1, operator, date2) => {
        // change date to full dates
        const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

        // compare
        if (operator === ">") {
            if (d1.getTime() > d2.getTime()) return true;
            else return false;
        }
        if (operator === ">=") {
            if (d1.getTime() >= d2.getTime()) return true;
            else return false;
        }
        if (operator === "<") {
            if (d1.getTime() < d2.getTime()) return true;
            else return false;
        }
        if (operator === "<=") {
            if (d1.getTime() <= d2.getTime()) return true;
            else return false;
        }
        if (operator === "=" || operator === "==" || operator === "===") {
            if (d1.getTime() === d2.getTime()) return true;
            else return false;
        }
    }
}